module.exports = __webpack_public_path__ + "img/dash_program.a2679cbf.png";